var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyCollectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 62,
    viewBox: "0 0 67 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01278 52.4873H28.8335V37.6666H9.01278V52.4873ZM9.01278 34.3333H28.8335V9.51264H9.01278V34.3333ZM32.1668 52.4873H51.9675V27.6666H32.1668V52.4873ZM32.1668 24.3333H51.9675V9.51264H32.1668V24.3333ZM5.67945 61.4981C4.14617 61.4981 2.81659 60.9352 1.6907 59.8094C0.56487 58.6835 0.00195312 57.3539 0.00195312 55.8206V6.17931C0.00195312 4.64059 0.56487 3.30634 1.6907 2.17656C2.81659 1.04673 4.14617 0.481812 5.67945 0.481812H55.3009C56.8396 0.481812 58.1738 1.04673 59.3036 2.17656C60.4334 3.30634 60.9983 4.64059 60.9983 6.17931V11H66.2175V16.2191H60.9983V28.3804H66.2175V33.6196H60.9983V45.7808H66.2175V51H60.9983V55.8206C60.9983 57.3539 60.4334 58.6835 59.3036 59.8094C58.1738 60.9352 56.8396 61.4981 55.3009 61.4981H5.67945ZM5.67945 55.8206H55.3009V6.17931H5.67945V55.8206Z",
    fill: "#AAAAAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCollectionIcon);
export default __webpack_public_path__ + "static/media/emptyCollectionIcon.22062a225c75b68bf4e5b87970e2cb05.svg";
export { ForwardRef as ReactComponent };